
import { ThemeProvider } from '../context/ThemeContext';
import { LanguageProvider } from '../context/LanguageContext';
import { AuthProvider } from '../context/AuthContext';
import { NotificationProvider } from '../context/Notification';
import { CartProvider } from '../context/CartContext';
import { SearchProvider } from '../context/SearchContext';
export const composeProviders = (...providers) => {
  return ({ children }) => {
    return providers.reduceRight(
      (child, Provider) => <Provider>{child}</Provider>,
      children
    );
  };
};

export const AllProviders = composeProviders(
  CartProvider,
  ThemeProvider,
  LanguageProvider,
  AuthProvider,
  NotificationProvider,
  SearchProvider
);